import { NavBar } from "../components/nav-bar";
import { ViewProduct } from "../components/view-product";
import { useParams } from "react-router-dom";
import { AssetBox } from "../components/asset-box";
import { useState, useEffect, useMemo } from 'react';
import { db, products_col_name, categories_col_name } from '../firebase';
import { collection, query, orderBy, getDocs, getDoc,doc,limit} from 'firebase/firestore';
import '../App.css';
import { Footer } from "../components/footer";
import logo from "../assets/logo.png"
import { brandName } from "../modules/modules";
import { useTranslation } from 'react-i18next';

const ProductDetailed = () => {
    const { id, name, desc, coverImg } = useParams();
    const { t } = useTranslation();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const decodedParams = {
        desc:decodeURIComponent(desc),
        coverImg: decodeURIComponent(coverImg),
        name: decodeURIComponent(name),
      };


    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const q = query(
                    collection(db, products_col_name),
                    limit(20),
                    // orderBy('createdAt', 'asc')
                );
                const querySnapshot = await getDocs(q);
                const data = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                    image: doc.data().coverImage || doc.data().image
                }));
                setProducts(data);
            } catch (err) {
                console.error('Error fetching products:', err);
            } finally {
                setLoading(false);
            }
        };
        fetchProducts();
    }, []);

    // const paginatedProducts = useMemo(() => {
    //     return products.slice(0, 5);
    // }, [products]);
    return (
        <>
            <hamlet>
                <title>{decodedParams.name}</title>
                    <meta name="description" content={decodedParams.desc} />
                    <meta property="og:title" content={decodedParams.name} />
                    <meta property="og:description" content={decodedParams.desc} />
                    <meta property="og:image" content={decodedParams.coverImg || logo} />
                    <meta property="og:url" content={window.location.href} />
                    <meta property="og:type" content="product" />
            </hamlet>
            <header>
                <div className="brand-title">
                    <h1>{brandName}</h1>
                </div>
                <div className="fixed-header">
                    <NavBar />
                </div>
            </header>
            <main>
                <section>
                    <ViewProduct productId={id} />
                </section>
                {/* other available products */}
                <section>
                    <h2 className="lined-text">{t("other-available-products")}</h2>
                    <div className="products-page__grid">
                        {products.map(product => (
                            <AssetBox key={product.id} product={product} />
                        ))}
                    </div>
                </section>
            </main>
            <footer>
                <Footer />
            </footer>
        </>
    );
};

export default ProductDetailed;


